module.exports = __webpack_public_path__ + "images/02646097e2b7694eb705b3284fc32e0dd7ad9a4e6bf8d2ddf0087a396234a568.svg";